import React, { useMemo, useRef, useState } from "react";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import { Label } from "./general";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { DIRECTION } from "services/general";
import ar from "react-phone-input-2/lang/ar.json";

const en = {}; // Use default English labels

const INPUT_CHANGE_EVENT = "change";

const PhoneField = ({ value, onChange, ...props }) => {
  const [typed, setTyped] = useState(value);
  const lastEmitted = useRef(value);
  const lastCountry = useRef(null);

  const inputValue = value === lastEmitted.current ? typed : value;

  const handleChange = (rawValue, data, event) => {
    const digits = rawValue.replace(/^\+/, "");
    const countryChanged =
      lastCountry.current !== null && data?.name !== lastCountry.current;
    lastCountry.current = data?.name ?? null;

    const nextTyped =
      countryChanged && event?.type !== INPUT_CHANGE_EVENT
        ? (data?.dialCode ?? "")
        : digits;
    const stored = nextTyped === data?.dialCode ? "" : nextTyped;

    setTyped(nextTyped);
    lastEmitted.current = stored;
    onChange?.(stored);
  };

  return <PhoneInput {...props} value={inputValue} onChange={handleChange} />;
};

const SharedPhoneInput = ({
  name,
  label,
  country = "sa",
  form: _form,
  required,
  validatePhone,
  requiredMessage,
  placeholder,
  ...rest
}) => {
  const { t } = useTranslation();

  const LOCAL = useMemo(
    () => (DIRECTION === "ltr" ? en : ar),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [DIRECTION, ar, en]
  );

  return (
    <div className="add-unit">
      {label && <Label required={required} title={label} />}

      <Form.Item
        name={name}
        validateTrigger={validatePhone ? "onBlur" : "onChange"}
        rules={[
          ...(required
            ? [
                {
                  required: true,
                  message:
                    requiredMessage || t("formItemRules.requiredMessage"),
                },
              ]
            : []),
          ...(validatePhone
            ? [
                {
                  validator: validatePhone,
                },
              ]
            : []),
        ]}
        hasFeedback
      >
        <PhoneField
          country={country}
          enableArrow={false}
          disableParentheses={true}
          preferredCountries={["sa"]}
          {...rest}
          distinct={true}
          enableSearch
          searchPlaceholder={t("search")}
          searchNotFound={t("noData")}
          localization={LOCAL}
          inputClass="phone-input-field"
          containerClass="phone-input-container"
          buttonClass={
            DIRECTION === "ltr" ? "en-phone-input-flag" : "ar-phone-input-flag"
          }
          placeholder={placeholder ?? ""}
        />
      </Form.Item>
    </div>
  );
};

export default SharedPhoneInput;
